module.exports = __webpack_public_path__ + "img/icon-woff.cb4621c8.svg";